type MealsType =
    | 'RO'
    | 'SC'
    | 'BB'
    | 'HB'
    | 'HBPlus'
    | 'FB'
    | 'FBPlus'
    | 'AI'
    | 'UAI';

export const convertMealsIds = (id: string): MealsType => {
    switch (id) {
        case '117':
            return 'RO';
        case '129':
            return 'SC';
        case '114':
            return 'BB';
        case '113':
            return 'HB';
        case '122':
            return 'HBPlus';
        case '112':
            return 'FB';
        case '121':
            return 'FBPlus';
        case '115':
            return 'AI';
        case '116':
            return 'UAI';
        default:
            return 'AI';
    }
};
